import React from "react";
import { Box, Typography, Paper, LinearProgress, Chip } from "@mui/material";
import { TrendingUp, People, PersonAdd } from "@mui/icons-material";

const CustomerAnalyticsCard = ({ customerAnalytics = {}, isLoading = false }) => {
    if (isLoading) {
        return (
            <Paper sx={{ p: 3, height: 200 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                    Customer Analytics
                </Typography>
                <Box
                    sx={{
                        height: 120,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        Loading...
                    </Typography>
                </Box>
            </Paper>
        );
    }

    const { totalCustomers = 0, activeCustomers = 0, conversionRate = "0.0" } = customerAnalytics;
    const inactiveCustomers = totalCustomers - activeCustomers;

    return (
        <Paper sx={{ p: 3, height: 200 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
                <People sx={{ color: "#ED2024" }} />
                Customer Analytics
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {/* Total Customers */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <People sx={{ color: "#666", fontSize: 20 }} />
                        <Typography variant="body2" color="text.secondary">
                            Total Customers
                        </Typography>
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: "#ED2024" }}>
                        {totalCustomers.toLocaleString()}
                    </Typography>
                </Box>

                {/* Active vs Inactive Breakdown */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <PersonAdd sx={{ color: "#4CAF50", fontSize: 20 }} />
                        <Typography variant="body2" color="text.secondary">
                            Active Customers
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <Chip label={`${activeCustomers}`} size="small" color="success" variant="filled" />
                        <Chip label={`${inactiveCustomers}`} size="small" color="default" variant="outlined" />
                    </Box>
                </Box>

                {/* Conversion Rate */}
                <Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Conversion Rate
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <TrendingUp sx={{ color: "#4CAF50", fontSize: 16 }} />
                            <Typography variant="body2" sx={{ fontWeight: 600, color: "#4CAF50" }}>
                                {conversionRate}%
                            </Typography>
                        </Box>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={parseFloat(conversionRate)}
                        sx={{
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                            "& .MuiLinearProgress-bar": {
                                backgroundColor:
                                    parseFloat(conversionRate) > 50
                                        ? "#4CAF50"
                                        : parseFloat(conversionRate) > 25
                                        ? "#FF9800"
                                        : "#F44336",
                                borderRadius: 4,
                            },
                        }}
                    />
                </Box>
            </Box>
        </Paper>
    );
};

export default CustomerAnalyticsCard;
